export default {
  title: '仓库管理',

  // 搜索筛选区域
  search: {
    warehouseCode: '仓库代码',
    warehouseCodePlaceholder: '模糊搜索仓库代码',
    warehouseName: '仓库名称',
    warehouseNamePlaceholder: '模糊搜索仓库名称',
    keyword: '关键词搜索',
    keywordPlaceholder: '仓库代码、名称、地址等',
    country: '国家',
    countryPlaceholder: '选择国家',
    language: '语种',
    languagePlaceholder: '选择语种',
    stateProvince: '州/省',
    stateProvincePlaceholder: '模糊搜索州/省',
    city: '城市',
    cityPlaceholder: '模糊搜索城市',
    warehouseType: '仓库类型',
    warehouseTypePlaceholder: '选择仓库类型',
    status: '状态',
    statusPlaceholder: '选择状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addWarehouse: '新增仓库',
    copyFromPlatform: '复制新增',
    batchImport: '批量导入',
    batchOperation: '批量操作（{count}）',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    batchDelete: '批量删除',
    edit: '编辑',
    more: '更多',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    warehouseCode: '仓库代码',
    warehouseName: '仓库名称',
    warehouseType: '仓库类型',
    country: '国家',
    city: '城市',
    address: '地址',
    dataSource: '数据来源',
    createdBy: '创建人',
    modifiedBy: '修改人',
    dateCreated: '创建时间',
    dateModified: '修改时间',
    status: '状态',
    operation: '操作',
    languageVersion: '语言版本'
  },

  // 表单
  form: {
    addTitle: '新增仓库',
    editTitle: '编辑仓库',
    warehouseCode: '仓库代码',
    warehouseCodePlaceholder: '请输入仓库代码',
    warehouseType: '仓库类型',
    warehouseTypePlaceholder: '选择仓库类型',
    warehouseNameCn: '仓库名称（中文）',
    warehouseNameCnPlaceholder: '请输入中文仓库名称',
    warehouseNameEn: '仓库名称（英文）',
    warehouseNameEnPlaceholder: '请输入英文仓库名称',
    country: '国家',
    countryPlaceholder: '选择国家',
    stateProvince: '州/省',
    stateProvincePlaceholder: '请输入州/省',
    city: '城市',
    cityPlaceholder: '请输入城市',
    postalCode: '邮政编码',
    postalCodePlaceholder: '请输入邮政编码',
    addressDetail: '详细地址',
    addressDetailPlaceholder: '请输入详细地址',
    contactPerson: '仓库联系人',
    contactPersonPlaceholder: '请输入仓库联系人',
    contactPhone: '仓库联系电话',
    contactPhonePlaceholder: '请输入仓库联系电话',
    status: '状态',
    statusPlaceholder: '选择状态',
    save: '保存',
    add: '新增'
  },

  // 仓库类型
  warehouseTypes: {
    amazon: '亚马逊仓',
    ecang: '易仓',
    other: '其他',
    factory: '工厂仓',
    fba: 'FBA 仓',
    thirdParty: '3PL 仓',
    selfOwned: '自有仓',
    overseas: '海外仓',
    transit: '中转仓',
    unknown: '未知'
  },

  // 确认对话框
  confirm: {
    enableItem: '确定要启用此仓库吗？',
    disableItem: '确定要禁用此仓库吗？',
    batchEnable: '确定要启用选中的 {count} 个仓库吗？',
    batchDisable: '确定要禁用选中的 {count} 个仓库吗？',
    batchDelete: '确定删除选中的 {count} 个仓库及其语言版本吗？删除后不可恢复。',
    deleteItem: '确定删除仓库“{name}”吗？删除后不可恢复。',
    deleteDraft: '确定删除这条尚未保存的新增仓库吗？',
    copyWillCreateTaskTitle: '创建后台复制任务',
    copyWillCreateTaskContent: '当前选择 {count} 条平台仓库数据，提交后将创建后台任务，可在任务中心查看处理详情。',
    copyWillCreateTaskOk: '创建任务',
    copyTaskRedirectTitle: '前往任务中心',
    copyTaskRedirectContent: '后台复制任务已提交，可前往任务中心查看处理详情。',
    copyTaskRedirectOk: '前往任务中心'
  },

  // 表单验证
  validation: {
    warehouseCodeRequired: '请输入仓库代码',
    warehouseCodeMinLength: '仓库代码至少3个字符',
    warehouseTypeRequired: '请选择仓库类型',
    warehouseNameCnRequired: '请输入中文仓库名称',
    warehouseNameEnRequired: '请输入英文仓库名称',
    warehouseNameEnNoChinese: '英文仓库名称不能包含其他语种字符',
    countryRequired: '请选择国家',
    cityRequired: '请输入城市',
    addressDetailRequired: '请输入详细地址',
    statusRequired: '请选择状态'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的仓库',
    selectToDisable: '请选择要禁用的仓库',
    selectToDelete: '请选择要删除的仓库',
    loadError: '仓库数据加载失败，请稍后重试',
    searchError: '搜索失败，请稍后重试',
    saveSuccess: '仓库保存成功',
    saveError: '保存失败，请稍后重试',
    updateSuccess: '仓库更新成功',
    updateError: '更新失败，请稍后重试',
    deleteSuccess: '仓库删除成功',
    deleteError: '仓库删除失败，请稍后重试',
    finishEditingFirst: '请先保存或取消当前编辑行',
    inlineRequired: '请完整填写当前行的必填字段',
    warehouseCodeDuplicate: '当前租户下已存在相同仓库代码',
    statusToggleSuccess: '仓库状态切换成功',
    statusToggleError: '状态切换失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个仓库',
    batchEnableError: '批量启用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个仓库',
    batchDisableError: '批量禁用失败，请稍后重试',
    batchDeleteSuccess: '已删除 {count} 个仓库',
    batchDeleteError: '批量删除失败，请稍后重试',
    formIncomplete: '请完整填写所有必填字段后再保存或关闭',
    platformLoadError: '平台仓库数据加载失败，请稍后重试',
    selectPlatformToCopy: '请选择要复制新增的平台仓库',
    copySelectedSuccess: '已复制新增 {count} 个仓库',
    copyAllSuccess: '已复制新增 {count} 个仓库，跳过 {skipped} 个已存在仓库',
    copyTaskSubmitted: '已创建仓库后台复制任务（任务中心ID：{taskId}），本次预计复制 {count} 条，可前往任务中心查看处理详情',
    copyTaskAlreadyRunning: '已有仓库复制任务正在执行（任务中心ID：{taskId}），请前往任务中心查看处理详情',
    copyError: '复制新增失败，请稍后重试'
  },

  platformCopy: {
    title: '复制新增平台仓库',
    keywordPlaceholder: '搜索仓库代码、名称、城市',
    selectedTitle: '已选择',
    selectedCount: '已选择 {count} 条',
    platformTitle: '平台仓库',
    platformCount: '平台共 {total} 条，本页可复制 {available} 条',
    clearSelected: '清空',
    remove: '移除',
    restore: '恢复',
    cancel: '取消',
    copySelected: '复制选中（{count}）',
    copyAll: '复制当前筛选全部',
    selectAllFiltered: '选择当前筛选条件下可复制的全部 {total} 条',
    querySelectedNotice: '已按当前筛选条件全选可复制数据 {total} 条，左侧不逐条展示全部数据；可在右侧取消勾选作为排除项，当前已排除 {excluded} 条',
    taskNotice: '当前选择 {count} 条，提交后将创建后台任务，可在任务中心查看处理详情',
    syncLimitNotice: '当前选择 {count} 条，超过同步复制上限 {limit} 条，请缩小筛选条件后重试',
    excludedPreview: '已排除明细',
    copyStatus: '复制状态',
    exists: '已存在',
    available: '可复制',
    allStatus: '全部',
    statusPlaceholder: '选择复制状态',
    copyAllConfirmTitle: '确认复制当前筛选全部',
    copyAllConfirmContent: '将复制当前筛选条件下未存在的仓库；已存在的仓库会自动跳过。当前筛选平台数据共 {count} 条。'
  },

  batchImport: {
    title: '批量导入仓库',
    uploadStep: '上传文件',
    previewStep: '解析预览',
    templateTip: '请先下载模板并按“一行一仓、中英文分列”填写；同一仓库代码重复时按后行非空值覆盖合并。',
    exampleNotice: '以上示例不计入最终导入，请从下一行开始填写',
    downloadTemplate: '下载模板',
    uploadTip: '点击或拖拽上传仓库导入文件',
    fileLimit: '仅支持 .xlsx 文件，单次最多导入 1000 个仓库',
    parsing: '解析中',
    parse: '解析并预览',
    totalCount: '仓库总数',
    validCount: '可导入',
    invalidCount: '异常',
    sourceRows: '文件行号',
    result: '校验结果',
    valid: '通过',
    invalid: '异常',
    errorReason: '异常原因',
    previous: '上一步',
    confirmImport: '确认导入（{count}）',
    dictionaryField: '字段',
    dictionaryValue: '可用值/说明',
    countryCodeDescription: '可填写中文名、英文名或国家代码，模糊匹配当前租户国家基础资料；匹配失败不允许导入',
    divisionDescription: '在已匹配国家下分别模糊匹配中英文；任一侧命中即回填基础资料双语，均未命中则按 Excel 原文导入',
    templateFilename: '仓库批量导入模板.xlsx',
    downloadError: '模板下载失败，请稍后重试',
    requiredField: '{field}不能为空',
    maxLength: '{field}不能超过 {max} 个字符',
    inconsistentMainFields: '同一仓库代码的主表字段必须保持一致',
    invalidWarehouseType: '仓库类型枚举值无效',
    invalidLocale: '语种仅支持 zh-CN 或 en-US',
    warehouseCodeExists: '当前租户下已存在相同仓库代码',
    invalidCountryCode: '国家代码不属于当前租户的国家基础资料',
    invalidCountry: '国家“{value}”未匹配到当前租户国家基础资料，不允许新建国家',
    countryAmbiguous: '国家“{value}”匹配到多条基础资料，请填写更精确的名称或国家代码',
    divisionAmbiguous: '{field}匹配到多条基础资料，请填写更精确的名称',
    divisionConflict: '{field}中英文分别匹配到不同基础资料',
    englishOnly: '{field}不能包含非英语语种字符',
    sharedPostalConflict: '旧模板同一仓库的中英文行邮政编码必须一致',
    languageRequired: '至少需要一种有效语言版本',
    missingColumns: '导入文件缺少字段：{columns}',
    noWorksheet: '导入文件中没有可读取的工作表',
    noRows: '导入文件中没有可导入的数据',
    tooManyWarehouses: '单次最多导入 {max} 个仓库，请拆分文件后重试',
    parseError: '文件解析失败，请检查模板格式',
    noValidRows: '没有可导入的有效仓库，请修正数据后重新解析',
    partialImportTip: '仅导入 {validCount} 个有效仓库，{invalidCount} 个异常仓库不会导入；异常数据可修正后重新上传。',
    partialImportSuccess: '已成功导入 {count} 个仓库，跳过 {skipped} 个异常仓库',
    importSuccess: '已成功导入 {count} 个仓库',
    importError: '仓库批量导入失败，请检查数据后重试',
    columns: {
      warehouseCode: '仓库代码*',
      warehouseNameCn: '仓库名称*（中文）',
      warehouseNameEn: '仓库名称*（英文）',
      country: '国家*',
      stateProvinceCn: '州/省（中文）',
      stateProvinceEn: '州/省（英文）',
      cityCn: '城市（中文）',
      cityEn: '城市（英文）',
      postalCode: '邮政编码',
      warehouseType: '仓库类型*',
      addressDetailCn: '详细地址*（中文）',
      addressDetailEn: '详细地址*（英文）',
      contactNameCn: '仓库联系人（中文）',
      contactNameEn: '仓库联系人（英文）',
      contactPhoneCn: '仓库联系电话（中文）',
      contactPhoneEn: '仓库联系电话（英文）'
    },
    instructions: {
      warehouseCode: '【必填】一行一仓；相同代码会覆盖/合并；勿改表头',
      warehouseNameCn: '【必填·中文】写入中文名称；中文列可含其他语种文字，不做语种校验',
      warehouseNameEn: '【必填·英文】写入英文名称；英文列禁止出现其他语种',
      country: '【必填·共享】中文名/英文名/代码均可；模糊匹配【国家】；不可新建；命中后回填中英文展示',
      stateProvinceCn: '【选填·中文】填省级（如兴安省）；可匹配【行政规划】；模糊匹配不到可新建；中文列不做语种校验',
      stateProvinceEn: '【选填·英文】填省级英文；有值时禁止中文；模糊匹配不到可新建',
      cityCn: '【选填·中文】填下级市/县；勿把市填进州/省；中文列不做语种校验；可新建',
      cityEn: '【选填·英文】填下级市/县英文；有值时禁止中文等其他语种',
      postalCode: '【选填·共享】中英共用，按当地格式填写',
      warehouseType: '【必填·共享】工厂仓/FBA仓/3PL仓/自有仓/海外仓/中转仓',
      addressDetailCn: '【必填·中文】详细地址中文；中文列不做语种校验',
      addressDetailEn: '【必填·英文】详细地址英文；禁止出现中文等其他语种',
      contactNameCn: '【选填·中文】联系人中文；中文列不做语种校验',
      contactNameEn: '【选填·英文】联系人英文；有值时禁止中文等其他语种',
      contactPhoneCn: '【选填】中文联系人的电话不校验语种，可以跟中文联系电话相同',
      contactPhoneEn: '【选填】英文联系人的电话，不校验语种，可以跟中文联系电话相同'
    }
  },

  languageVersion: {
    count: '{count} 种语言',
    title: '语言版本',
    add: '添加语种',
    noData: '暂无语言版本',
    locale: '语种',
    chinese: '中文',
    english: '英语',
    country: '国家',
    stateProvince: '州/省',
    city: '城市',
    postalCode: '邮政编码',
    addressDetail: '详细地址',
    contactName: '仓库联系人',
    contactPhone: '仓库联系电话',
    operation: '操作',
    keepOne: '至少需要保留一种语言版本',
    localeDuplicate: '同一仓库内语种不可重复',
    addressRequired: '请填写所有语言版本的详细地址',
    englishNoChinese: '英语版本的州/省、城市、详细地址和联系人不能包含其他语种字符'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 国家选项
  countries: {
    US: '美国',
    GB: '英国',
    DE: '德国',
    FR: '法国',
    IT: '意大利',
    ES: '西班牙',
    CA: '加拿大',
    AU: '澳大利亚',
    JP: '日本',
    KR: '韩国',
    SG: '新加坡',
    TH: '泰国',
    MY: '马来西亚',
    MX: '墨西哥',
    BR: '巴西'
  }
}
